'use client';
import Box from '@mui/material/Box';
import appData from '@/lib/appData';
import { Container, Grid, IconButton, Stack, Typography } from '@mui/material';
import FacebookIcon from '@/components/icons/FacebookIcon';
import InstagramIcon from '@/components/icons/InstagramIcon';
import TikTokIcon from '../icons/TikTokIcon';
import YouTubeIcon from '../icons/YouTubeIcon';
import FadeIn from './FadeIn';
import Script from 'next/script';
import Row from './Row';
import Image from 'next/image';

const socialIconsMap = {
  facebook: <FacebookIcon sx={{ fill: 'white' }} />,
  instagram: <InstagramIcon sx={{ fill: 'white' }} />,
  tiktok: <TikTokIcon sx={{ fill: 'white' }} />,
  youtube: <YouTubeIcon sx={{ fill: 'white' }} />,
}
const Footer: React.FC = () => {

  const { footer, socials } = appData;

  return (
    <>
      <Script src="https://plugins.flockler.com/embed/1786379bde50825e0e5ede4c2f0a540b/199613c124e094c402c16576a7ca83e4" async/>

      <Box
        bgcolor={'grey.200'}
        sx={{
          py: { xs: 32, lg: 48 },
          bgcolor: 'grey.200',
          backgroundImage: 'url(/assets/image/bg_social.svg)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: {xs: 'top center', lg: 'top right'},
          backgroundSize: {xs: 'contain', lg: 'contain'},
          backgroundBlendMode: 'color-dodge',
        }}
      >
        <Container>
          <Row justifyContent={"space-between"} alignItems={"center"}>
            <Grid size={{xs: 12, lg: 3}}>
              <Typography variant="displaySM" component="h3">Join our community</Typography>
              {/* <Typography variant="headlineSMMedium" component="p" mt={{xs: 4, lg: 8}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Typography> */}
            </Grid>
            <Grid size={{xs: 12, lg: 8}} mt={{xs: 20, lg: 0}}>
              <Box id="flockler-embed-199613c124e094c402c16576a7ca83e4" />
            </Grid>
          </Row>
        </Container>
      </Box>
      {socials.length > 0 && (
        <Box textAlign={'center'} py={{xs: 32, lg: 48}} display={'flex'} flexDirection={'column'} alignItems={'center'} gap={4}>
          <FadeIn>
            <Typography variant="displaySM" component="h2" color="inherit">Follow Us</Typography>
            <Typography variant="headlineSMMedium" component="p" color="inherit">Follow us on our social</Typography>
          </FadeIn>

          <Stack direction="row" spacing={12}>
            {socials.map((item, index) => (
              <FadeIn key={item.icon} transition={{ delay: index * 0.1 }}>
                <IconButton
                  color="primary"
                  href={item.link}
                  target='_blank'
                  rel="noopener noreferrer"
                  aria-label={`Visita il nostro profilo ${item.icon}`}
                  sx={{
                    padding: 6,
                    backgroundColor: 'primary.main',
                    '&:hover': { backgroundColor: 'primary.dark' },
                  }}
                >
                  {socialIconsMap[item.icon as keyof typeof socialIconsMap]}
                </IconButton>
              </FadeIn>
            ))}
          </Stack>
        </Box>
      )}
      <Box component="footer" bgcolor="grey.900" color="white" py={{ xs: 12, lg: 8 }}>
        <Container>
          <Stack direction={{ xs: "column", lg: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", lg: "center" }}>
            <Typography variant="captionLGRegular">{footer.copyright}</Typography>

            <Stack direction="row" flexWrap={'wrap'} gap={12} rowGap={6} mt={{ xs: 16, lg: 0 }}>
              {footer.links.map((item) => (
                <Typography key={item.label} variant="bodySMSemibold" sx={{ textDecoration: 'underline', textUnderlineOffset: '4px' }}>
                  <a href={item.link} target='_blank' rel="noopener noreferrer">{item.label}</a>
                </Typography>
              ))}
            </Stack>
          </Stack>
        </Container>
      </Box>
    </>
  );
}

export default Footer;